

















































































































































































































































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';
import { filterDeburr } from '../../utils/functions';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { ResponseObj, UltrassomFormData, DppFinal } from '../../../../back/src/types';
import { Ultrassom } from '../../../../back/src/entity/Ultrassom';
import {
  sexoBebeItens,
  normalAlteradoItens,
  apresentacaoFetalItems,
  placentaLocalizacaoItens,
} from '../../utils/constants';
import { Gestacao } from '../../../../back/src/entity/Gestacao';

export default Vue.extend({
  name: 'UltrassomForm',
  props: {
    paciente: {
      type: Object as () => Paciente,
      default: {} as Paciente,
    },
    ultrassom: {
      type: null || Object as () => Ultrassom,
      default: null,
    },
  },
  data() {
    return {
      test: {
        required: '',
        integer: '',
      },
      loading: false,
      menuDataUltrassom: false,
      dppUsInvalida: false,
      searchInput: '',
      DppFinal,
      form: {
        gestacaoGemelar: false,
        dppFinalUs: false,
        dataUltrassom: '',
        dataProvavelPartoUs: '',
        igSemanas: null,
        igDias: null,
        placentaLocalizacao: null,
        placentaGrau: null,
        observacoes: '',
        // bebes
        sexo1: null,
        peso1: null,
        ila1: null,
        morfologia1: null,
        doppler1: null,
        apresFetal1: null,
        sexo2: null,
        peso2: null,
        ila2: null,
        morfologia2: null,
        doppler2: null,
        apresFetal2: null,
      },
      items: {
        sexoBebe: sexoBebeItens,
        normalAlterado: normalAlteradoItens,
        apresentacao: apresentacaoFetalItems,
        placentaLocalizacao: placentaLocalizacaoItens,
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
        positiveInteger: [
          (v: string) => (Number.isInteger(Number(v)) && Number(v) >= 0) || 'Valor deve ser um número inteiro positivo',
        ],
      },
    };
  },
  computed: {
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    vColClass(): string {
      return 'pt-1 pb-2';
    },
    vColLabelClass(): string {
      return 'pt-1 pb-2 mb-1';
    },
    formUltrassom():
      Vue & { validate: () => boolean, reset: () => void, resetValidation: () => void } {
      return this.$refs.formUltrassom as Vue & {
        validate: () => boolean,
        reset: () => void,
        resetValidation: () => void
      };
    },
    rulesIg(): any[] {
      return _.concat(
        this.form.dppFinalUs ? this.rules.required : [],
        this.rules.positiveInteger,
      );
    },
    dataProvavelPartoUsFormatada(): string {
      const dataProvavelPartoUs = this.calculaDppUs();
      if (dataProvavelPartoUs) {
        const momentDataProvavelPartoUs = moment(dataProvavelPartoUs);
        if (momentDataProvavelPartoUs.isValid()) {
          return momentDataProvavelPartoUs.format('DD/MM/YYYY');
        }
      }
      return '';
    },
    dataUltrassomFormatada(): string {
      if (this.form.dataUltrassom) {
        const momentData = moment(this.form.dataUltrassom);
        if (momentData.isValid()) {
          return momentData.format('DD/MM/YYYY');
        }
      }
      return '';
    },
    gestacaoAtual() {
      return this.paciente.gestacao_atual ? this.paciente.gestacao_atual : null;
    },
    gestacaoGemelarAlterada() {
      return this.form.gestacaoGemelar !== this.gestacaoAtual.gestacao_gemelar;
    },
  },
  mounted() {
    this.form.gestacaoGemelar = this.gestacaoAtual.gestacao_gemelar;
    this.preencheForm();
  },
  methods: {
    filterDeburr(item: any, queryText: string, itemText: string) {
      return filterDeburr(queryText, itemText);
    },
    preencheForm() {
      if (_.has(this.ultrassom, 'id')) {
        this.form.dppFinalUs = false;
        this.form.dataUltrassom = this.ultrassom.data_ultrassom
          ? moment(this.ultrassom.data_ultrassom).format('YYYY-MM-DD') : '';
        this.form.igSemanas = this.ultrassom.ig_semanas;
        this.form.igDias = this.ultrassom.ig_dias;
        this.form.dataProvavelPartoUs = this.calculaDppUs();
        this.form.placentaLocalizacao = this.ultrassom.placenta_localizacao;
        this.form.placentaGrau = this.ultrassom.placenta_grau;
        this.form.observacoes = this.ultrassom.observacoes;
        this.form.sexo1 = this.ultrassom.sexo1;
        this.form.peso1 = this.ultrassom.peso_gramas1;
        this.form.ila1 = this.ultrassom.ila1;
        this.form.morfologia1 = this.ultrassom.morfologia1;
        this.form.doppler1 = this.ultrassom.doppler1;
        this.form.apresFetal1 = this.ultrassom.apres_fetal1;
        this.form.sexo2 = this.ultrassom.sexo2;
        this.form.peso2 = this.ultrassom.peso_gramas2;
        this.form.ila2 = this.ultrassom.ila2;
        this.form.morfologia2 = this.ultrassom.morfologia2;
        this.form.doppler2 = this.ultrassom.doppler2;
        this.form.apresFetal2 = this.ultrassom.apres_fetal2;
      } else {
        this.form.dppFinalUs = false;
        this.form.dataUltrassom = '';
        this.form.dataProvavelPartoUs = '';
        this.form.igSemanas = null;
        this.form.igDias = null;
        this.form.placentaLocalizacao = null;
        this.form.placentaGrau = null;
        this.form.observacoes = '';
        this.form.sexo1 = null;
        this.form.peso1 = null;
        this.form.ila1 = null;
        this.form.morfologia1 = null;
        this.form.doppler1 = null;
        this.form.apresFetal1 = null;
        this.form.sexo2 = null;
        this.form.peso2 = null;
        this.form.ila2 = null;
        this.form.morfologia2 = null;
        this.form.doppler2 = null;
        this.form.apresFetal2 = null;
      }
      this.calculaDppUs();
      // this.formUltrassom.resetValidation();
    },
    minMaxDia() {
      if (Number(this.form.igDias) > 6) {
        this.form.igDias = 6;
      } else if (Number(this.form.igDias) < 0) {
        this.form.igDias = 0;
      }
    },
    minMaxSemana() {
      if (Number(this.form.igSemanas) > 99) {
        this.form.igSemanas = 99;
      } else if (Number(this.form.igSemanas) < 0) {
        this.form.igSemanas = 0;
      }
    },
    igEmDias(): number | null {
      const semanas: number = Number(this.form.igSemanas);
      const dias: number = Number(this.form.igDias);
      if (Number.isNaN(semanas) || Number.isNaN(dias)) {
        return null;
      }
      const igDias: number = (semanas * 7) + dias;
      if (igDias > 0) {
        return igDias;
      }
      return null;
    },
    calculaDppUs(): string {
      this.dppUsInvalida = false;
      const igSemanas = Number(this.form.igSemanas);
      const igDias = Number(this.form.igDias);
      if (!this.form.dataUltrassom || (!igSemanas && !igDias)) {
        return '';
      }
      const momentDate = moment(this.form.dataUltrassom)
        .subtract(igSemanas, 'w')
        .subtract(igDias, 'd')
        .add(40, 'w');
      if (!momentDate.isValid()) {
        this.dppUsInvalida = true;
        return '';
      }
      return momentDate.format('YYYY-MM-DD');
    },
    avaliaInt(val: string) {
      return Number.isNaN(parseInt(val, 10)) ? null : parseInt(val, 10);
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading = true;
      if (!this.formUltrassom.validate()) {
        this.loading = false;
        return;
      }
      if (this.form.dppFinalUs || this.gestacaoGemelarAlterada) {
        this.atualizaGestacao();
      }
      const formData: UltrassomFormData = {
        paciente_id: this.paciente.id,
        gestacao_id: this.gestacaoAtual.id,
        data_ultrassom: moment(this.form.dataUltrassom).toDate(),
        ig_semanas: Number(this.form.igSemanas),
        ig_dias: Number(this.form.igDias),
        placenta_localizacao: this.form.placentaLocalizacao || null,
        placenta_grau: this.avaliaInt(this.form.placentaGrau),
        observacoes: this.form.observacoes || null,
        ila1: this.avaliaInt(this.form.ila1),
        doppler1: this.form.doppler1 || null,
        peso_gramas1: this.form.peso1 || null,
        morfologia1: this.form.morfologia1 || null,
        apres_fetal1: this.form.apresFetal1 || null,
        sexo1: this.form.sexo1 || null,
        ila2: this.avaliaInt(this.form.ila2),
        doppler2: this.form.doppler2 || null,
        peso_gramas2: this.form.peso2 || null,
        morfologia2: this.form.morfologia2 || null,
        apres_fetal2: this.form.apresFetal2 || null,
        sexo2: this.form.sexo2 || null,
      };
      try {
        let response: ResponseObj<Ultrassom>;
        if (this.ultrassom === null) {
          response = await Requester.ultrassom.criaUltrassom(formData);
          if (response.errors.length > 0) {
            this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          } else {
            this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Dados salvos com sucesso' });
            this.$emit('novo-ultrassom', response.data);
            // vai limpar o form
            this.preencheForm();
            this.$emit('close');
          }
        } else {
          formData.id = this.ultrassom.id;
          response = await Requester.ultrassom.alteraUltrassom(formData);
          if (response.errors.length > 0) {
            this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          } else {
            this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Dados salvos com sucesso' });
            this.$emit('atualiza-ultrassom', response.data);
            this.$emit('close');
          }
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    async atualizaGestacao() {
      const formData: Gestacao = new Gestacao();
      _.assign(formData, this.gestacaoAtual);
      if (this.form.dppFinalUs) {
        formData.data_exame_us = moment(this.form.dataUltrassom).toDate();
        formData.ig_exame_us_dias = this.igEmDias();
        formData.dpp_final = DppFinal.U;
        formData.data_provavel_parto = moment(this.calculaDppUs()).toDate();
        formData.data_provavel_parto_us = formData.data_provavel_parto;
      }
      if (this.gestacaoGemelarAlterada) {
        formData.gestacao_gemelar = this.form.gestacaoGemelar;
      }
      try {
        const response: ResponseObj<Gestacao> = await Requester.gestacao.alteraGestacao(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      }
    },
  },
  watch: {
    ultrassom() {
      this.preencheForm();
    },
  },
});
